/**
 * Route for `behavioral-anomaly-detection-abnormal-user-actions`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BehavioralAnomalyDetectionAbnormalUserActionsPage } from "../features/behavioral-anomaly-detection-abnormal-user-actions/BehavioralAnomalyDetectionAbnormalUserActionsPage";

export const behavioralAnomalyDetectionAbnormalUserActionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/behavioral-anomaly-detection-abnormal-user-actions",
	component: BehavioralAnomalyDetectionAbnormalUserActionsPage,
});

export default behavioralAnomalyDetectionAbnormalUserActionsRoute;
